import { render, staticRenderFns } from "./omnisend.vue?vue&type=template&id=25c9a0f4&scoped=true&"
import script from "./omnisend.vue?vue&type=script&lang=js&"
export * from "./omnisend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c9a0f4",
  null
  
)

export default component.exports